module.exports = __webpack_public_path__ + "static/img/3_1_1_3.3dbc7911.jpg";